import ForgotPassword from "../pages/Guest/ForgotPassword"
import GuestOnly from "../utils/Protected/GuestOnly"
import { Route } from "react-router-dom"
import Login from "../pages/Guest/Login"
import Layout from "../layouts/guest"

const GuestRoutes = (
  <Route path="/" element={<Layout />}>
    <Route path="" element={<GuestOnly><Login /></GuestOnly>} />
    <Route path="login" element={<GuestOnly><Login /></GuestOnly>} />
    <Route path="forgot-password" element={<GuestOnly><ForgotPassword /></GuestOnly>} />
  </Route>
)

export default GuestRoutes